<template>
  <div class="create-team">
    <slot name="create-team-name"></slot>
    <div class="common-account-select">
      <slot name="common-account-select-wrapper"></slot>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CreateTeamLayout',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  .create-team {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 20px;
  }
  .common-account-select {
    flex-grow: 1;
    max-height: 380px;
  }
</style>



// WEBPACK FOOTER //
// src/common/im/team/create/CreateTeamLayout.vue